import { render } from "./PanelStylePreview.vue?vue&type=template&id=25f8f47b"
import script from "./PanelStylePreview.vue?vue&type=script&lang=js"
export * from "./PanelStylePreview.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__